import { Box, Button, HStack, Input, VStack, useColorModeValue, useToast,Text } from "@chakra-ui/react";
import { useState } from "react";
import axios from "axios";
import { Navigate, useNavigate, useLocation } from "react-router-dom";  // Import the useNavigate hook
import PublicLayout from "../../Coaching/PublicLayout";
import bandpic from "../../resources/studentpics/pexels-artyusufpatel-12187128.jpg";
import LoginImageBand from "./LoginImageBand";
import ReCAPTCHA from 'react-google-recaptcha';

interface SuperuserLoginProps {
  onLogin: (newToken: string, refreshToken:string) => void; // Add this prop
}

interface LoginRequest {
    username: string;
    password: string;
    expected_role: string;
    tenant_id: number;
}
const SECRET_KEY = process.env.REACT_APP_SUPER_ROUTE_KEY; // Define your secret key for access

const SuperuserLogin: React.FC<SuperuserLoginProps> = ({ onLogin }) => {
    
  const [recaptchaToken, setRecaptchaToken] = useState<string | null>(null);
  const [recaptchaError, setRecaptchaError] = useState<string | null>(null);

  const handleRecaptchaChange = (token: string | null) => {
    setRecaptchaToken(token);
    setRecaptchaError(null); // Clear error if recaptcha passes
  };

  const handleRecaptchaError = () => {
    setRecaptchaError('Failed to verify reCAPTCHA. Please try again.');
  };

  const toast = useToast();

  const recaptchaKey = process.env.REACT_APP_GOOGLE_CAPTCHA_KEY;

  if (!recaptchaKey) {
    throw new Error('REACT_APP_GOOGLE_CAPTCHA_KEY is not defined');
  }

    const [loginData, setLoginData] = useState<LoginRequest>({
        username: '',
        password: '',
        expected_role: 'superuser', 
        tenant_id: 1  
    });

    const navigate = useNavigate();  // Use the hook here

    const location = useLocation();
    const params = new URLSearchParams(location.search);

    if (params.get('access_key') !== SECRET_KEY) {
        return <Navigate to="/" replace />;
    }

    // Handle input changes
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value } = e.target;
        setLoginData({
            ...loginData,
            [name]: name === "tenant_id" ? parseInt(value) : value
        });
    };

    const handleLogin = async () => {
            console.log("Login button clicked from Superlogin.tsx"); 

            if (!recaptchaToken) {
              alert('Please complete the reCAPTCHA verification.');
              setRecaptchaError('Please complete the reCAPTCHA verification.');
                return;
              }      

              const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";

              console.log("api URL :"+apiurl); 

              // Send the CAPTCHA token to your backend for verification
              const response = await fetch(apiurl+"/verify-captcha", {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({ recaptchaToken }),
            });

            const data = await response.json();

            if (data.success) {
             // alert("CAPTCHA verified successfully!");
              // Proceed with form submission logic
            } else {
              toast({
                title: 'Captcha Failed',
                description:
                  'Captcha Verification Failed. Please try again.',
                status: 'error',
                duration: 5000,
                isClosable: true,
              });
              return;
            }
            
            try {
                
                const apiurl = process.env.REACT_APP_API_URL || "https://default-url.com";
                if (!apiurl) {
                  throw new Error('REACT_APP_LOGIN_API_URL is not defined');
              } 
                    console.log("Login Request"+JSON.stringify(loginData))
                    
                    const response = await axios.post(`${apiurl}/super-login`, loginData);
                    const token = response.data.access_token;
                    const refreshToken = response.data.refresh_token;

                    // Call onLogin with the received token
                    onLogin(token,refreshToken);
                    
                    console.log("token as stored in local storage"+localStorage.getItem("token"))
                    // After successful login, redirect to dashboard
                  //  navigate('/coaching/super/dashboard');
                   navigate(`/platform/super/`);
                  } catch (error) {
                    if (axios.isAxiosError(error) && error.response) {
                      const status = error.response.status;
                
                      if (status === 429) {
                        toast({
                          title: 'Too Many Requests',
                          description:
                            'You have exceeded the rate limit. Please try again later.',
                          status: 'warning',
                          duration: 5000,
                          isClosable: true,
                        });
                      } else {
                        toast({
                          title: 'Login Failed',
                          description: error.response.data.detail ||
                            'An unexpected error occurred. Please try again.',
                          status: 'error',
                          duration: 5000,
                          isClosable: true,
                        });
                      }
                    } else {
                      toast({
                        title: 'Network Error',
                        description: 'Unable to connect to the server. Please check your network.',
                        status: 'error',
                        duration: 5000,
                        isClosable: true,
                      });
                    }
                  }
                };
        

  return (
    <PublicLayout>
      <LoginImageBand title="Superuser Login"    
                 imagepath={bandpic} 
      />
    <Box maxW="400px" mx="auto" my={8}
      border="1px solid"
        borderColor="gray.400"
        borderRadius="md"
        mt={6}
        p={4}      
        mb={6}
      >
      <VStack spacing={4}>
        <Input 
          placeholder="Username"
          name="username"
          value={loginData.username}
          onChange={handleChange}
          required
        />
        <Input 
          placeholder="Password"
          type="password"
          name="password"
          value={loginData.password}
          onChange={handleChange}
         required
        />
        </VStack>

        <VStack mt={5} spacing={4}>
        {recaptchaError && <Text color="red.500">{recaptchaError}</Text>}
            {/* Recaptcha */}
            <ReCAPTCHA sitekey={recaptchaKey} onChange={handleRecaptchaChange} onErrored={handleRecaptchaError} />

        <Button   border="1px solid"
        borderColor="blue.200"
        borderRadius="md" width={40} onClick={handleLogin}>Login</Button>
        </VStack>
    </Box>
    </PublicLayout>
  );
};

export default SuperuserLogin;
